import { useEffect, useMemo } from 'react'
import { useModuleContext } from '../contexts/module'
import useSWR from 'swr'

function useAttachments() {
  const { dispatch, state: { artworkInformation, labels } } = useModuleContext()

  const { data: attachments } = useSWR<Array<ABTypes.Attachments.Attachment>>(
    artworkInformation?.artworkInfo?.id ? `/msvc/v1/attachments/items/2/${artworkInformation?.artworkInfo?.id}` : null
  )

  const authenticationUrl = attachments?.filter(({ type }) => type === 'AUTH')[0]?.url ?? null
  const artistsBioUrl = attachments?.filter(({ type }) => type === 'ABIO')[0]?.url ?? null
  const additionalInfoUrl = attachments?.filter(({ type }) => type === 'FAIN')[0]?.url ?? null
  const conditionReportUrl = attachments?.filter(({ type }) => type === 'CREP')[0]?.url ?? null

  const authenticationLabel = labels?.Attachments?.AUTH
  const artistsBioLabel = labels?.Attachments?.ABIO
  const additionalInfoLabel = labels?.Attachments?.FAIN
  const conditionReportLabel = labels?.Attachments?.CREP

  const data = useMemo(() => ({
    authentication: {
      label: authenticationLabel,
      url: authenticationUrl,
      icon: 'certificate'
    },
    artistsBio: {
      label: artistsBioLabel,
      url: artistsBioUrl,
      icon: 'colour'
    },
    additionalInfo: {
      label: additionalInfoLabel,
      url: additionalInfoUrl,
      icon: 'add-info'
    },
    conditionReport: {
      label: conditionReportLabel,
      url: conditionReportUrl,
      icon: 'condition-report'
    }
  }), [additionalInfoLabel, additionalInfoUrl, artistsBioLabel, artistsBioUrl,
    authenticationLabel, authenticationUrl, conditionReportLabel, conditionReportUrl])

  useEffect(() => {
    dispatch({
      type: 'SET_ATTACHMENTSINFO',
      payload: data
    })
  }, [dispatch, data])
}

export default useAttachments
